import React, { type MouseEvent } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Button, { type Spacing } from '@atlaskit/button/new';
import ReplyLeftIcon from '@atlaskit/icon-lab/core/reply-left';

const messages = defineMessages({
	reply: {
		id: 'inline-comments-common.comments.replies.footer.reply',
		defaultMessage: 'Reply',
		description: 'Label for the button to reply to a comment',
	},
});

type ReplyButtonProps = {
	handleReplyButtonClick: (event: MouseEvent<HTMLButtonElement>) => void;
	isOffline?: boolean;
	spacing?: Spacing;
};

export const ReplyButton = ({ handleReplyButtonClick, isOffline, spacing }: ReplyButtonProps) => {
	const { formatMessage } = useIntl();

	return (
		<Button
			spacing={spacing}
			appearance="subtle"
			isDisabled={isOffline}
			onClick={handleReplyButtonClick}
			iconBefore={ReplyLeftIcon}
		>
			{formatMessage(messages.reply)}
		</Button>
	);
};
